module.exports = __webpack_public_path__ + "img/telegram.22c84ae1.svg";